import React from 'react';
import PropTypes from 'prop-types';

function OrdersPagination({ numberOfPages, activePageNumber, onPageNumberChange }) {
    function displayPagination() {
        const pagination = [];

        if (!shouldDisplayPaginator()) {
            return pagination;
        }

        if (activePageNumber >= 3) {
            pagination.push(getFirstPageNumber());
        }

        if (activePageNumber > 3) {
            pagination.push(getSpreadButton());
        }

        const pageNumberButtons = getPageNumberButtons();
        const updatedPagination = pagination.concat(pageNumberButtons);

        if (activePageNumber < numberOfPages - 2) {
            updatedPagination.push(<span key={-1} className='page'>...</span>);
        }

        updatedPagination.push(getLastPageNumber());
        return updatedPagination;
    }

    function shouldDisplayPaginator() {
        return activePageNumber > 0 && numberOfPages >= activePageNumber;
    }

    function getFirstPageNumber() {
        return <span key={1}
            onClick={(e) => { goToPage(e, 1); }}
            className={`page ${activePageNumber === 1 ? 'active' : ''}`}>{'1'}</span>;
    }

    function getSpreadButton() {
        return <span key={0} className='page'>...</span>;
    }

    function getPageNumberButtons() {
        const pageNumberButtons = [];
        for (let i = activePageNumber - 1; i < activePageNumber + 2; i++) {
            if (i > 0 && i < numberOfPages) {
                pageNumberButtons.push(<span key={i}
                    onClick={(e) => { goToPage(e, i); }}
                    className={`page ${i === activePageNumber ? 'active' : ''}`}>
                    {`${i}`}
                </span>);
            }
        }

        return pageNumberButtons;
    }

    function getLastPageNumber() {
        return <span key={numberOfPages}
            onClick={(e) => { goToPage(e, numberOfPages); }}
            className={`page ${activePageNumber === numberOfPages ? 'active' : ''}`}>
            {`${numberOfPages}`}
        </ span>;
    }

    function goToPage(event, pageNumber) {
        event.preventDefault();

        onPageNumberChange(pageNumber);
    }

    function nextPage() {
        onPageNumberChange(activePageNumber + 1 > numberOfPages ? numberOfPages : activePageNumber + 1);
    }

    function prevPage() {
        onPageNumberChange(activePageNumber - 1 < 1 ? 1 : activePageNumber - 1);
    }

    return (
        <div className='orders-pagination'>
            {shouldDisplayPaginator() ? <span onClick={prevPage}
                className={`order-previous ${activePageNumber === 1 ? 'disabled' : ''}`}>
                <svg aria-hidden='true'
                    focusable='false'
                    data-prefix='fas'
                    data-icon='chevron-left'
                    role='img'
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 320 512'
                    className=''>
                    <path fill='currentColor'
                        d='M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z'>
                    </path>
                </svg>
            </span> : null}
            {displayPagination()}
            {shouldDisplayPaginator() ? <span onClick={nextPage}
                className={`order-next ${activePageNumber === numberOfPages ? 'disabled' : ''}`}>
                <svg aria-hidden='true'
                    focusable='false'
                    data-prefix='fas'
                    data-icon='chevron-right'
                    role='img'
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 320 512'
                    className=''>
                    <path fill='currentColor'
                        d='M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z'>
                    </path>
                </svg>
            </span> : null}
        </div>
    );
}

OrdersPagination.propTypes = {
    numberOfPages: PropTypes.number.isRequired,
    activePageNumber: PropTypes.number.isRequired,
    onPageNumberChange: PropTypes.func.isRequired
};


export default OrdersPagination;
